import { useOrgRole } from './useOrgRole';

/**
 * @deprecated Use `useOrgRole()` — o nome mente sobre o escopo.
 *
 * Isto é um SHIM sobre `useOrgRole`, mantido enquanto os 19 arquivos que o consomem migram um a
 * um. A forma de retorno é idêntica à da versão antiga, então nenhum call site precisa mudar
 * junto com esta troca.
 *
 * ── O que mudou por baixo ──
 * A implementação anterior consultava `memberships` SEM `org_id`: ser admin em qualquer
 * organização ligava `isAdmin` em TODAS. Medido em 31/08: 92 pares (pessoa, org) de 34 pessoas
 * recebiam UI de administrador onde não são admin — inclusive nos guards de `/settings`,
 * `/contratos` e da integração ZapSign. Agora é escopado pela org corrente.
 *
 * Ela também mantinha estado em `useState` fora do React Query (imune ao purge de
 * `perms_version`) e disparava um `supabase.auth.getUser()` próprio. Ambos sumiram: a fonte
 * agora é `my_effective_access`, que a Sidebar já monta em toda sessão.
 */
export function useIsAdmin() {
  const { isOrgAdmin, isSuperAdmin, loading } = useOrgRole();
  return { isAdmin: isOrgAdmin, isSuperAdmin, loading };
}
